webpackJsonp([81679748166845],{

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/architecture.71a3a2b7.png";

/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frame-mock.ed257d2e.png";

/***/ }),

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss1.0f7b1a47.png";

/***/ }),

/***/ 1187:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss10.9e39d5f6.png";

/***/ }),

/***/ 1188:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss11.fa193113.png";

/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss12.6702da26.png";

/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss13.891c617f.jpg";

/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss14.66cd852f.jpg";

/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss15.e75e740e.jpg";

/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss16.ddcc718c.jpg";

/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss17.1b75eedc.jpg";

/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss18.1b75eedc.jpg";

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss19.aeb48af1.jpg";

/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss2.421ffb7f.png";

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss20.8a2b214a.jpg";

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss3.88884718.png";

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss4.546ef212.png";

/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss5.672773ff.png";

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss6.9b82bcb5.png";

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss7.452c7e0a.png";

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss8.71a5ea4d.png";

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss9.c2e31018.png";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImages = __webpack_require__(112);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	var _gallery = __webpack_require__(136);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StudySmartPage = function StudySmartPage(_ref) {
	    var children = _ref.children,
	        location = _ref.location;
	
	    var mockImg = __webpack_require__(1183);
	    var architectureImg = __webpack_require__(1182);
	    var screenshots = [{ src: __webpack_require__(1186) }, { src: __webpack_require__(1197) }, { src: __webpack_require__(1199) }, { src: __webpack_require__(1200) }, { src: __webpack_require__(1201) }, { src: __webpack_require__(1202) }, { src: __webpack_require__(1203) }, { src: __webpack_require__(1204) }, { src: __webpack_require__(1205) }, { src: __webpack_require__(1187) }, { src: __webpack_require__(1188) }, { src: __webpack_require__(1189) }, { src: __webpack_require__(1190) }, { src: __webpack_require__(1191) }, { src: __webpack_require__(1192) }, { src: __webpack_require__(1193) }, { src: __webpack_require__(1194) }, { src: __webpack_require__(1195) }, { src: __webpack_require__(1196) }, { src: __webpack_require__(1198) }];
	    return _react2.default.createElement(
	        'div',
	        { className: 'portofolio-project-wrapper ' },
	        _react2.default.createElement(
	            'div',
	            { className: 'portofolio-project studysmart ' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                ' Study Smart'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-subtitle' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-status' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Status: '
	                    ),
	                    ' Completed'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-link' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://app-study-smart.herokuapp.com/#/', target: '_blank' },
	                        'View Application'
	                    )
	                )
	            ),
	            _react2.default.createElement('img', { src: mockImg, alt: 'Studysmart Screenshots' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-intro' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Introduction'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'The project\u2019s aim wass to develop a platform that brings closer tutors and students, providing an easier way to find suitable tutors/ students, as well as to manage the process of private lessons.  In order to achieve this, three applications were developed: a web application, a mobile application and RESTful Web service, which is consumed by both of the other apps.',
	                    _react2.default.createElement('br', null),
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    'This project was submited for the award of Bachelor\'s degree in Computer Science from University of Southampton.',
	                    _react2.default.createElement('br', null),
	                    'The software was developed in 7 months, during my 3rd university year (October 2015 - April 2016).',
	                    _react2.default.createElement('br', null),
	                    'The full report is available ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://drive.google.com/file/d/1t3_oIqXR-f6bFf-2TB844Ug3t_Q2b-zw/view?usp=sharing', target: '_blank' },
	                        ' here'
	                    ),
	                    '.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-tags' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AngularJS'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#NodeJS'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Ionic'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#MongoDB'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#MongoLab'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AWS'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Heroku'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AgileDevelopment'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-architecture' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Architecture '
	                ),
	                _react2.default.createElement('img', { src: architectureImg, alt: 'Studysmart Architecture' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-features' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Features'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'User Authentication using PassportJS'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'JWT based Authorization'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Push Notifications using Ionic Push'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Using MonogLab - MongoDB DBaaS'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'File uploading (AWS S3)'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Web app and the API deployed to Heroku'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-screenshots' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Screenshots'
	                ),
	                _react2.default.createElement(_gallery2.default, { images: screenshots })
	            )
	        )
	    );
	};
	
	exports.default = StudySmartPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portofolio-studysmart-js-9e5837bbccf8704658cf.js